import React from "react";
import ModalFormCamion from "./ModalFormCamion";

const ModalCamion = ({ show, handleClose, camion }) => {
  return (
    <ModalFormCamion show={show} handleClose={handleClose} camion={camion} />
  );
};

export default ModalCamion;
